import { combineReducers } from "redux";
import template from "./template";

export default combineReducers({ template });
